import { useMemo } from 'react';
import { ApiClient } from './client';
import { useAccessTokenProvider } from '@core/auth/useAccessToken';

export function useApiClient(): ApiClient {
  const getAccessToken = useAccessTokenProvider();
  return useMemo(() => new ApiClient({ getAccessToken }), [getAccessToken]);
}
